/**
 * Which legacy per-database records pack a Stripe subscription is, from its
 * moduleName. Packs were named "Database Credit Pack N" / "Product Database
 * Credit Pack N" until the rename to "... Records Pack N", and subscriptions
 * keep the name they were created with, so both spellings are recognised.
 * "product database ..." also contains "database ...", so it is checked first.
 */
export const legacyDatabasePackKind = (
  moduleName: string,
): 'product' | 'database' | null => {
  const name = moduleName.toLowerCase();
  if (
    name.includes('product database records pack') ||
    name.includes('product database credit pack')
  ) {
    return 'product';
  }
  if (
    name.includes('database records pack') ||
    name.includes('database credit pack')
  ) {
    return 'database';
  }
  return null;
};
